module.exports = __webpack_public_path__ + "img/Missie.d28f8033.jpg";